import { render, staticRenderFns } from "./KpCollectionsList.vue?vue&type=template&id=2664105a&"
import script from "./KpCollectionsList.vue?vue&type=script&lang=js&"
export * from "./KpCollectionsList.vue?vue&type=script&lang=js&"
import style0 from "./KpCollectionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports